module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_advisor01-0dba1d57834f0ee183856eaad8a05f28.jpg";